import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageRendererComponent } from './image-renderer.component';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    ImageRendererComponent,
  ],
  exports: [
    CommonModule,
    ImageRendererComponent,
  ]
})
export class ImageRendererModule { }
